import React from "react";
import styled from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";
import Circle from "./Circle";

import CaseIcon from "./CaseIcon";

const JunoTile = styled.button`
  width: 100%;

  position: relative;
  background-color: var(--juno-color-off-white);
  border-radius: 20px;
  border: 2px solid transparent;
  transition: border 0.2s ease-out 0s;
  text-align: left;

  /* Ensure content aligns to top when tiles are stretched to equal heights */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  padding: 24px;
  ${mediaQueries.md} {
    padding: 40px;
  }
  svg {
    color: var(--juno-color-purple);
  }
  :hover {
    cursor: pointer;
    color: var(--juno-color-purple);
    border-color: var(--juno-color-purple);
  }
`;

const JunoTileContent = styled.div`
  h3 {
    color: var(--juno-color-text-1);
    font-size: 24px;
    margin-top: 32px;
    margin-bottom: 0;
    ${mediaQueries.md} {
      font-size: 28px;
      margin-top: 64px;
    }
  }
  p {
    color: var(--juno-color-text-3);
    font-size: var(--juno-font-size-body-sm);
    ${mediaQueries.md} {
      font-size: var(--juno-font-size-body-md);
    }
  }
  p:first-letter {
    text-transform: uppercase;
  }
`;

const JunoTileIcon = styled.div`
  color: var(--juno-color-purple);
`;

const JunoTileCount = styled(Circle)`
  position: absolute;
  top: 12px;
  right: 12px;
  ${mediaQueries.md} {
    top: 24px;
    right: 24px;
  }
`;

function Tile(props) {
  return (
    <JunoTile onClick={props.onClick}>
      <JunoTileContent>
        <JunoTileIcon>
          {props.count && props.count > 0 && (
            <JunoTileCount color="white" background="purple" dataTestId="things-to-do">
              {props.count}
            </JunoTileCount>
          )}

          <CaseIcon type={props.caseType} size="40" />
        </JunoTileIcon>

        <h3>{props.title}</h3>
        <p>{props.children}</p>
      </JunoTileContent>
    </JunoTile>
  );
}

export default Tile;
